import { render, staticRenderFns } from "./corporateDetail.vue?vue&type=template&id=4efe82ed&"
import script from "./corporateDetail.vue?vue&type=script&lang=js&"
export * from "./corporateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports